import React, { FC } from 'react';
import styled from 'styled-components';

const StyledYoutube = styled.div`
   {
    width: 100%;
    padding-bottom: 56.25%;
    height: 0px;
    position: relative;
    margin-bottom: 1.5rem;
  }
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

export type Props = {
  /**
   * YouTubeのURL
   */
  YouTubeURL: string;
};

/**
 * YouTubeプレイヤーコンポーネント
 */
const Youtube: FC<Props> = ({ YouTubeURL }: Props) => {
  return (
    <>
      <StyledYoutube>
        <iframe
          title="yotube"
          src={YouTubeURL}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </StyledYoutube>
    </>
  );
};

export default Youtube;
